var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconBox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 23 14",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.888 13.487c-1.163 0-2.1-.937-2.1-2.1V4.112l-1.613-.037c-.112 0-.225-.075-.3-.188C.8 3.775.838 3.662.913 3.55l1.65-2.213A2.114 2.114 0 014.25.512h14.213c.487 0 .975.188 1.35.525l2.775 2.588c.075.075.075.187.075.262a.253.253 0 01-.225.15h-1.913l-.037 7.313c0 1.162-.938 2.1-2.1 2.1-.038.038-13.5.037-13.5.037zm10.35-1.5c0 .338.262.6.6.6h2.55c.675 0 1.2-.524 1.2-1.2V4.112l-1.613-.037a.621.621 0 01-.45-.188l-2.25-1.95c-.037 0-.037 10.05-.037 10.05zm-11.55-.6c0 .675.525 1.2 1.2 1.2h8.85c.337 0 .6-.262.6-.6V2.575l-1.05 1.237a.716.716 0 01-.525.263H3.688zM4.25 1.45c-.375 0-.712.187-.937.45l-.9 1.162 10.2.075 1.275-1.65z",
    fill: "#000"
  })));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-box-1d2fb88e07b369880424ab790fd56391.svg";
export { SvgIconBox as Component };